import React, { Component } from "react";

import FormatUtils from "../../utils/formatUtils";
import { BACKEND_CONFIG } from "../../config/consts";

class PolicyCancellationRequests extends Component {
  getDocumentPath() {
    let path;

    if (window.location.href[window.location.href.length] === "/")
      path = window.location.href
        .substr(0, window.location.href.length - 1)
        .split("/");
    else path = window.location.href.split("/");
    return (
      BACKEND_CONFIG.apiUrl +
      "documents/client/" +
      path[path.length - 1] +
      "/clientDocuments/" +
      this.props.data.Data["FileId"] +
      "/preview"
    );
  }

  render() {
    return (
      <div>
        <div className={"communications-title"}>
          <span>{this.props.data.Title}</span>
          {this.props.data.Data["FileId"] == null ? (
            ""
          ) : (
            <a
              rel="noopener noreferrer"
              target="_blank"
              className={"view-button float-right"}
              href={this.getDocumentPath()}
            >
              View
            </a>
          )}
        </div>
        <div className={"clear communications-desc"}>
          <span>{this.props.data.Data.Description}</span>
        </div>
        <div className={"communications-data"}>
          <div className="data-line">
            <span className={"key-data"}>
              {this.props.data.Data["Status"] === "Requested"
                ? "Requested Date"
                : "Completed Date"}
            </span>
            <span className="value-data float-right">
              {FormatUtils.formatDate(this.props.data.Date)}
            </span>
          </div>
          <div className="data-line">
            <span className={"key-data"}>Line of Business</span>
            <span className="value-data float-right">
              {this.props.data.Data["LineOfBusiness"]}
            </span>
          </div>
          <div className="data-line">
            <span className={"key-data"}>Carrier</span>
            <span className="value-data float-right">
              {this.props.data.Data["Carrier"]}
            </span>
          </div>
          <div className="data-line">
            <span className={"key-data"}>Policy Number</span>
            <span className="value-data float-right">
              {this.props.data.Data["PolicyNumber"]}
            </span>
          </div>
          <div className="data-line">
            <span className={"key-data"}>Status</span>
            <span className="value-data float-right">
              {this.props.data.Data["Status"]}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default PolicyCancellationRequests;
